angular
  .module('ccs')
  .controller(
    'LogoutCtrl',
    function (
      $rootScope,
      $state,
      Procore,
      CurrentUser,
      Auth,
      Notification,
      $log,
    ) {
      $log.debug('LogoutCtrl')

      Procore.destroyTokens(() => {})

      Auth.removeCookieToken()
      CurrentUser.reset()
      Notification.success('You have been successfully logged out.')

      $(window).unload(function () {
        localStorage.clear()
      })
      $rootScope.returnToState = ''
      $rootScope.isUserLogOut = true
      $state.go('login')
    },
  )
